import { Menu, MenuItem, Typography } from '@mui/material'
import React, { useState } from 'react'

const MobileIndustrySectorDropdown = ({ row }) => {
    const [anchorElIndustry, setAnchorElIndustry] = useState(null);
    const openIndustry = Boolean(anchorElIndustry);

    const handleClickIndustry = (event) => {
        setAnchorElIndustry(event.currentTarget);
    };

    const handleCloseIndustry = () => {
        setAnchorElIndustry(null);
    };
    const categories = row?.categories ? row?.categories?.split(",") : "";
    const firstCategory = categories?.[0]?.trim();
    // const remainingCategoriesCount = categories && categories[0] ? `+${categories.length - 1}` : "Not Available";

    const remainingCategoriesCount = categories?.length === 1 && categories?.[0] !== "" ? null : categories?.length > 1 ? `+${categories.length - 1}` : "Not Available"
    const allCategories = row?.categories;
    const categoriesArray = allCategories?.split(",");
    return (
        <>
            <Typography
                variant="subtitle2"
                fontWeight="bold"
                onClick={handleClickIndustry}
                sx={{ cursor: "pointer" }}
            >
                {firstCategory && remainingCategoriesCount ? (
                    <p className="industry-text-dropdown-head-main-propect">

                        {firstCategory ? firstCategory.length > 11 ? `${firstCategory?.substr(0, 11)}...` : firstCategory : "Not Available"}
                        {remainingCategoriesCount}
                    </p>
                ) : (
                    <p className="industry-text-dropdown-head-main-propect">
                        {firstCategory?.substr(0, 11)} {remainingCategoriesCount}
                    </p>
                )}
            </Typography>

            <Menu
                anchorEl={anchorElIndustry}
                open={openIndustry}
                onClose={handleCloseIndustry}
                PaperProps={{
                    elevation: 3,
                    sx: { borderRadius: 2, mt: 1 },
                }}
            >
                {categoriesArray?.map((item, index) => (
                    <MenuItem onClick={handleCloseIndustry}>
                        {item}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

export default MobileIndustrySectorDropdown
